import { n as e, t } from "./rolldown-runtime-CbXtAM7H.js";
import { u as n } from "./forms-D-uIurhY.js";
var r = t(e => {
  var t = Symbol.for(`react.transitional.element`);
  var n = Symbol.for(`react.fragment`);
  function r(e, n, r) {
    var i = null;
    if (r !== undefined) {
      i = `${r}`;
    }
    if (n.key !== undefined) {
      i = `${n.key}`;
    }
    if (`key` in n) {
      r = {};
      for (var a in n) {
        if (a !== `key`) {
          r[a] = n[a];
        }
      }
    } else {
      r = n;
    }
    n = r.ref;
    return {
      $$typeof: t,
      type: e,
      key: i,
      ref: n === undefined ? null : n,
      props: r
    };
  }
  e.Fragment = n;
  e.jsx = r;
  e.jsxs = r;
});
var i = t((e, t) => {
  t.exports = r();
});
var a = e(n(), 1);
var o = i();
var s = a.createContext(undefined);
var c = e => {
  let t = a.useContext(s);
  if (e) {
    return e;
  }
  if (!t) {
    throw Error(`No QueryClient set, use QueryClientProvider to set one`);
  }
  return t;
};
var l = ({
  client: e,
  children: t
}) => {
  a.useEffect(() => {
    e.mount();
    return () => {
      e.unmount();
    };
  }, [e]);
  return <s.Provider value={e}>{t}</s.Provider>;
};
var u = {
  setTimeout: (e, t) => setTimeout(e, t),
  clearTimeout: e => clearTimeout(e),
  setInterval: (e, t) => setInterval(e, t),
  clearInterval: e => clearInterval(e)
};
var d = new class {
  #e = u;
  setTimeoutProvider(e) {
    this.#e = e;
  }
  setTimeout(e, t) {
    return this.#e.setTimeout(e, t);
  }
  clearTimeout(e) {
    this.#e.clearTimeout(e);
  }
  setInterval(e, t) {
    return this.#e.setInterval(e, t);
  }
  clearInterval(e) {
    this.#e.clearInterval(e);
  }
}();
function f(e) {
  setTimeout(e, 0);
}
var p = typeof window > `u` || `Deno` in globalThis;
function m() {}
function h(e, t) {
  if (typeof e == `function`) {
    return e(t);
  } else {
    return e;
  }
}
function g(e) {
  return typeof e == `number` && e >= 0 && e !== Infinity;
}
function _(e, t) {
  return Math.max(e + (t || 0) - Date.now(), 0);
}
function v(e, t) {
  if (typeof e == `function`) {
    return e(t);
  } else {
    return e;
  }
}
function y(e, t) {
  let {
    type: n = `all`,
    exact: r,
    fetchStatus: i,
    predicate: a,
    queryKey: o,
    stale: s
  } = e;
  if (o) {
    if (r) {
      if (t.queryHash !== x(o, t.options)) {
        return false;
      }
    } else if (!C(t.queryKey, o)) {
      return false;
    }
  }
  if (n !== `all`) {
    let e = t.isActive();
    if (n === `active` && !e || n === `inactive` && e) {
      return false;
    }
  }
  return (typeof s != `boolean` || t.isStale() === s) && (!i || i === t.state.fetchStatus) && (!a || !!a(t));
}
function b(e, t) {
  let {
    exact: n,
    status: r,
    predicate: i,
    mutationKey: a
  } = e;
  if (a) {
    if (!t.options.mutationKey) {
      return false;
    }
    if (n) {
      if (S(t.options.mutationKey) !== S(a)) {
        return false;
      }
    } else if (!C(t.options.mutationKey, a)) {
      return false;
    }
  }
  return (!r || t.state.status === r) && (!i || !!i(t));
}
function x(e, t) {
  return (t?.queryKeyHashFn || S)(e);
}
function S(e) {
  return JSON.stringify(e, (e, t) => D(t) ? Object.keys(t).sort().reduce((e, n) => {
    e[n] = t[n];
    return e;
  }, {}) : t);
}
function C(e, t) {
  if (e === t) {
    return true;
  }
  if (typeof e != typeof t) {
    return false;
  }
  if (e && t && typeof e == `object` && typeof t == `object`) {
    if (Array.isArray(e) && Array.isArray(t)) {
      if (t.length > e.length) {
        return false;
      }
      for (let n = 0; n < t.length; n++) {
        if (!C(e[n], t[n])) {
          return false;
        }
      }
      return true;
    }
    let n = Object.keys(t);
    for (let r of n) {
      if (!C(e[r], t[r])) {
        return false;
      }
    }
    return true;
  }
  return false;
}
var ee = Object.prototype.hasOwnProperty;
function w(e, t, n = 0) {
  if (e === t) {
    return e;
  }
  if (n > 500) {
    return t;
  }
  let r = E(e) && E(t);
  if (!r && (!D(e) || !D(t))) {
    return t;
  }
  let i = (r ? e : Object.keys(e)).length;
  let a = r ? t : Object.keys(t);
  let o = a.length;
  let s = r ? Array(o) : {};
  let c = 0;
  for (let l = 0; l < o; l++) {
    let o = r ? l : a[l];
    let u = e[o];
    let d = t[o];
    if (u === d) {
      s[o] = u;
      if (r ? l < i : ee.call(e, o)) {
        c++;
      }
      continue;
    }
    if (u === null || d === null || typeof u != `object` || typeof d != `object`) {
      s[o] = d;
      continue;
    }
    let f = w(u, d, n + 1);
    s[o] = f;
    if (f === u) {
      c++;
    }
  }
  if (i === o && c === i) {
    return e;
  } else {
    return s;
  }
}
function T(e, t) {
  if (!t || Object.keys(e).length !== Object.keys(t).length) {
    return false;
  }
  for (let n in e) {
    if (e[n] !== t[n]) {
      return false;
    }
  }
  return true;
}
function E(e) {
  return Array.isArray(e) && e.length === Object.keys(e).length;
}
function D(e) {
  if (!O(e)) {
    return false;
  }
  let t = Object.getPrototypeOf(e);
  let n = t?.constructor;
  if (n === undefined) {
    return true;
  }
  if (typeof n != `function`) {
    return false;
  }
  let r = n.prototype;
  return !!O(r) && !!r.hasOwnProperty(`isPrototypeOf`) && t === Object.prototype;
}
function O(e) {
  return Object.prototype.toString.call(e) === `[object Object]`;
}
function te(e) {
  return new Promise(t => {
    d.setTimeout(t, e);
  });
}
function k(e, t, n) {
  if (typeof n.structuralSharing == `function`) {
    return n.structuralSharing(e, t);
  } else if (n.structuralSharing === false) {
    return t;
  } else {
    return w(e, t);
  }
}
function ne(e, t, n = 0) {
  let r = [...e, t];
  if (n && r.length > n) {
    return r.slice(1);
  } else {
    return r;
  }
}
function re(e, t, n = 0) {
  let r = [t, ...e];
  if (n && r.length > n) {
    return r.slice(0, -1);
  } else {
    return r;
  }
}
var A = Symbol();
function j(e, t) {
  if (!e.queryFn && t?.initialPromise) {
    return () => t.initialPromise;
  } else if (!e.queryFn || e.queryFn === A) {
    return () => Promise.reject(Error(`Missing queryFn: '${e.queryHash}'`));
  } else {
    return e.queryFn;
  }
}
function M(e, t) {
  if (typeof e == `function`) {
    return e(...t);
  } else {
    return !!e;
  }
}
function ie(e, t, n) {
  let r = false;
  let i;
  Object.defineProperty(e, "signal", {
    enumerable: true,
    get: () => {
      i ??= t();
      if (r) {
        return i;
      } else {
        r = true;
        if (i.aborted) {
          n();
        } else {
          i.addEventListener(`abort`, n, {
            once: true
          });
        }
        return i;
      }
    }
  });
  return e;
}
var ae = () => p;
var N = () => ae();
var P = class {
  constructor() {
    this.listeners = new Set();
    this.subscribe = this.subscribe.bind(this);
  }
  subscribe(e) {
    this.listeners.add(e);
    this.onSubscribe();
    return () => {
      this.listeners.delete(e);
      this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {}
  onUnsubscribe() {}
};
var F = new class extends P {
  #e;
  #t;
  #n;
  constructor() {
    super();
    this.#n = e => {
      if (typeof window < `u` && window.addEventListener) {
        let t = () => e();
        window.addEventListener(`visibilitychange`, t, false);
        return () => {
          window.removeEventListener(`visibilitychange`, t);
        };
      }
    };
  }
  onSubscribe() {
    if (!this.#t) {
      this.setEventListener(this.#n);
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.#t?.();
      this.#t = undefined;
    }
  }
  setEventListener(e) {
    this.#n = e;
    this.#t?.();
    this.#t = e(e => {
      if (typeof e == `boolean`) {
        this.setFocused(e);
      } else {
        this.onFocus();
      }
    });
  }
  setFocused(e) {
    if (this.#e !== e) {
      this.#e = e;
      this.onFocus();
    }
  }
  onFocus() {
    let e = this.isFocused();
    this.listeners.forEach(t => {
      t(e);
    });
  }
  isFocused() {
    if (typeof this.#e == `boolean`) {
      return this.#e;
    } else {
      return globalThis.document?.visibilityState !== `hidden`;
    }
  }
}();
var oe = f;
function se() {
  let e = [];
  let t = 0;
  let n = e => {
    e();
  };
  let r = e => {
    e();
  };
  let i = oe;
  let a = r => {
    if (t) {
      e.push(r);
    } else {
      i(() => {
        n(r);
      });
    }
  };
  let o = () => {
    let t = e;
    e = [];
    if (t.length) {
      i(() => {
        r(() => {
          t.forEach(e => {
            n(e);
          });
        });
      });
    }
  };
  return {
    batch: e => {
      let n;
      t++;
      try {
        n = e();
      } finally {
        t--;
        if (!t) {
          o();
        }
      }
      return n;
    },
    batchCalls: e => (...t) => {
      a(() => {
        e(...t);
      });
    },
    schedule: a,
    setNotifyFunction: e => {
      n = e;
    },
    setBatchNotifyFunction: e => {
      r = e;
    },
    setScheduler: e => {
      i = e;
    }
  };
}
var I = se();
var L = new class extends P {
  #e = true;
  #t;
  #n;
  constructor() {
    super();
    this.#n = e => {
      if (typeof window < `u` && window.addEventListener) {
        let t = () => e(true);
        let n = () => e(false);
        window.addEventListener(`online`, t, false);
        window.addEventListener(`offline`, n, false);
        return () => {
          window.removeEventListener(`online`, t);
          window.removeEventListener(`offline`, n);
        };
      }
    };
  }
  onSubscribe() {
    if (!this.#t) {
      this.setEventListener(this.#n);
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.#t?.();
      this.#t = undefined;
    }
  }
  setEventListener(e) {
    this.#n = e;
    this.#t?.();
    this.#t = e(this.setOnline.bind(this));
  }
  setOnline(e) {
    if (this.#e !== e) {
      this.#e = e;
      this.listeners.forEach(t => {
        t(e);
      });
    }
  }
  isOnline() {
    return this.#e;
  }
}();
function ce(e) {
  return Math.min(2 ** e * 1000, 30000);
}
function R(e) {
  return (e ?? `online`) !== `online` || L.isOnline();
}
var z = class extends Error {
  constructor(e) {
    super(`CancelledError`);
    this.revert = e?.revert;
    this.silent = e?.silent;
  }
};
function B(e) {
  let t = false;
  let n = 0;
  let r;
  let i = `pending`;
  let a;
  let o;
  let s = new Promise((e, t) => {
    a = e;
    o = t;
  });
  s.catch(m);
  let c = () => i !== `pending`;
  let l = t => {
    if (!c()) {
      let n = new z(t);
      g(n);
      e.onCancel?.(n);
    }
  };
  let u = () => {
    t = true;
  };
  let d = () => {
    t = false;
  };
  let f = () => F.isFocused() && (e.networkMode === `always` || L.isOnline()) && e.canRun();
  let p = () => R(e.networkMode) && e.canRun();
  let h = e => {
    if (!c()) {
      r?.();
      i = `resolved`;
      a(e);
    }
  };
  let g = e => {
    if (!c()) {
      r?.();
      i = `rejected`;
      o(e);
    }
  };
  let _ = () => new Promise(t => {
    r = e => {
      if (c() || f()) {
        t(e);
      }
    };
    e.onPause?.();
  }).then(() => {
    r = undefined;
    if (!c()) {
      e.onContinue?.();
    }
  });
  let v = () => {
    if (c()) {
      return;
    }
    let r;
    let i = n === 0 ? e.initialPromise : undefined;
    try {
      r = i ?? e.fn();
    } catch (e) {
      r = Promise.reject(e);
    }
    Promise.resolve(r).then(h).catch(r => {
      if (c()) {
        return;
      }
      let i = e.retry ?? (N() ? 0 : 3);
      let a = e.retryDelay ?? ce;
      let o = typeof a == `function` ? a(n, r) : a;
      let s = i === true || typeof i == `number` && n < i || typeof i == `function` && i(n, r);
      if (t || !s) {
        g(r);
        return;
      }
      n++;
      e.onFail?.(n, r);
      te(o).then(() => f() ? undefined : _()).then(() => {
        if (t) {
          g(r);
        } else {
          v();
        }
      });
    });
  };
  return {
    promise: s,
    status: () => i,
    cancel: l,
    continue: () => {
      r?.();
      return s;
    },
    cancelRetry: u,
    continueRetry: d,
    canStart: p,
    start: () => {
      if (p()) {
        v();
      } else {
        _().then(v);
      }
      return s;
    }
  };
}
var V = class {
  #e;
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout();
    if (g(this.gcTime)) {
      this.#e = d.setTimeout(() => {
        this.optionalRemove();
      }, this.gcTime);
    }
  }
  updateGcTime(e) {
    this.gcTime = Math.max(this.gcTime || 0, e ?? (N() ? Infinity : 300000));
  }
  clearGcTimeout() {
    if (this.#e !== undefined) {
      d.clearTimeout(this.#e);
      this.#e = undefined;
    }
  }
};
function le(e) {
  return {
    onFetch: (t, n) => {
      let r = t.options;
      let i = t.fetchOptions?.meta?.fetchMore?.direction;
      let a = t.state.data?.pages || [];
      let o = t.state.data?.pageParams || [];
      let s = {
        pages: [],
        pageParams: []
      };
      let c = 0;
      let l = async () => {
        let n = false;
        let l = e => {
          ie(e, () => t.signal, () => n = true);
        };
        let u = j(t.options, t.fetchOptions);
        let d = async (e, r, i) => {
          if (n) {
            return Promise.reject(t.signal.reason);
          }
          if (r == null && e.pages.length) {
            return Promise.resolve(e);
          }
          let a = (() => {
            let e = {
              client: t.client,
              queryKey: t.queryKey,
              pageParam: r,
              direction: i ? `backward` : `forward`,
              meta: t.options.meta
            };
            l(e);
            return e;
          })();
          let o = await u(a);
          let {
            maxPages: s
          } = t.options;
          let c = i ? re : ne;
          return {
            pages: c(e.pages, o, s),
            pageParams: c(e.pageParams, r, s)
          };
        };
        if (i && a.length) {
          let e = i === `backward`;
          let t = e ? ue : H;
          let n = {
            pages: a,
            pageParams: o
          };
          s = await d(n, t(r, n), e);
        } else {
          let t = e ?? a.length;
          do {
            let e = c === 0 ? o[0] ?? r.initialPageParam : H(r, s);
            if (c > 0 && e == null) {
              break;
            }
            s = await d(s, e);
            c++;
          } while (c < t);
        }
        return s;
      };
      t.fetchFn = t.options.persister ? () => t.options.persister?.(l, {
        client: t.client,
        queryKey: t.queryKey,
        meta: t.options.meta,
        signal: t.signal
      }, n) : l;
    }
  };
}
function H(e, {
  pages: t,
  pageParams: n
}) {
  let r = t.length - 1;
  if (t.length > 0) {
    return e.getNextPageParam(t[r], t, n[r], n);
  } else {
    return undefined;
  }
}
function ue(e, {
  pages: t,
  pageParams: n
}) {
  if (t.length > 0) {
    return e.getPreviousPageParam?.(t[0], t, n[0], n);
  } else {
    return undefined;
  }
}
var de = class extends V {
  #e;
  #t;
  #n;
  #r;
  #i;
  #a;
  #o;
  #s;
  constructor(e) {
    super();
    this.#s = false;
    this.#o = e.defaultOptions;
    this.setOptions(e.options);
    this.observers = [];
    this.#i = e.client;
    this.#r = this.#i.getQueryCache();
    this.queryKey = e.queryKey;
    this.queryHash = e.queryHash;
    this.#t = G(this.options);
    this.state = e.state ?? this.#t;
    this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  get queryType() {
    return this.#e;
  }
  get promise() {
    return this.#a?.promise;
  }
  setOptions(e) {
    this.options = {
      ...this.#o,
      ...e
    };
    if (e?._type) {
      this.#e = e._type;
    }
    this.updateGcTime(this.options.gcTime);
    if (this.state && this.state.data === undefined) {
      let e = G(this.options);
      if (e.data !== undefined) {
        this.setState(W(e.data, e.dataUpdatedAt));
        this.#t = e;
      }
    }
  }
  optionalRemove() {
    if (!this.observers.length && this.state.fetchStatus === `idle`) {
      this.#r.remove(this);
    }
  }
  setData(e, t) {
    let n = k(this.state.data, e, this.options);
    this.#c({
      data: n,
      type: `success`,
      dataUpdatedAt: t?.updatedAt,
      manual: t?.manual
    });
    return n;
  }
  setState(e) {
    this.#c({
      type: `setState`,
      state: e
    });
  }
  cancel(e) {
    let t = this.#a?.promise;
    this.#a?.cancel(e);
    if (t) {
      return t.then(m).catch(m);
    } else {
      return Promise.resolve();
    }
  }
  destroy() {
    super.destroy();
    this.cancel({
      silent: true
    });
  }
  get resetState() {
    return this.#t;
  }
  reset() {
    this.destroy();
    this.setState(this.resetState);
  }
  isActive() {
    return this.observers.some(e => v(e.options.enabled, this) !== false);
  }
  isDisabled() {
    if (this.getObserversCount() > 0) {
      return !this.isActive();
    } else {
      return this.options.queryFn === A || !this.isFetched();
    }
  }
  isFetched() {
    return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
  }
  isStatic() {
    return this.getObserversCount() > 0 && this.observers.some(e => v(e.options.staleTime, this) === `static`);
  }
  isStale() {
    if (this.getObserversCount() > 0) {
      return this.observers.some(e => e.getCurrentResult().isStale);
    } else {
      return this.state.data === undefined || this.state.isInvalidated;
    }
  }
  isStaleByTime(e = 0) {
    if (this.state.data === undefined) {
      return true;
    } else if (e === `static`) {
      return false;
    } else if (this.state.isInvalidated) {
      return true;
    } else {
      return !_(this.state.dataUpdatedAt, e);
    }
  }
  onFocus() {
    this.observers.find(e => e.shouldFetchOnWindowFocus())?.refetch({
      cancelRefetch: false
    });
    this.#a?.continue();
  }
  onOnline() {
    this.observers.find(e => e.shouldFetchOnReconnect())?.refetch({
      cancelRefetch: false
    });
    this.#a?.continue();
  }
  addObserver(e) {
    if (!this.observers.includes(e)) {
      this.observers.push(e);
      this.clearGcTimeout();
      this.#r.notify({
        type: `observerAdded`,
        query: this,
        observer: e
      });
    }
  }
  removeObserver(e) {
    let t = this.observers.indexOf(e);
    if (t !== -1) {
      this.observers.splice(t, 1);
      if (!this.observers.length) {
        if (this.#a) {
          if (this.#s || this.state.fetchStatus === `paused` && this.state.status === `pending`) {
            this.#a.cancel({
              revert: true
            });
          } else {
            this.#a.cancelRetry();
          }
        }
        this.scheduleGc();
      }
      this.#r.notify({
        type: `observerRemoved`,
        query: this,
        observer: e
      });
    }
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    if (!this.state.isInvalidated) {
      this.#c({
        type: `invalidate`
      });
    }
  }
  async fetch(e, t) {
    if (this.state.fetchStatus !== `idle` && this.#a?.status() !== `rejected`) {
      if (this.state.data !== undefined && t?.cancelRefetch) {
        this.cancel({
          silent: true
        });
      } else if (this.#a) {
        this.#a.continueRetry();
        return this.#a.promise;
      }
    }
    if (e) {
      this.setOptions(e);
    }
    if (!this.options.queryFn) {
      let e = this.observers.find(e => e.options.queryFn);
      if (e) {
        this.setOptions(e.options);
      }
    }
    let n = new AbortController();
    let r = e => {
      Object.defineProperty(e, "signal", {
        enumerable: true,
        get: () => {
          this.#s = true;
          return n.signal;
        }
      });
    };
    let i = () => {
      let e = j(this.options, t);
      let n = (() => {
        let e = {
          client: this.#i,
          queryKey: this.queryKey,
          meta: this.meta
        };
        r(e);
        return e;
      })();
      this.#s = false;
      if (this.options.persister) {
        return this.options.persister(e, n, this);
      } else {
        return e(n);
      }
    };
    let a = (() => {
      let e = {
        fetchOptions: t,
        options: this.options,
        queryKey: this.queryKey,
        client: this.#i,
        state: this.state,
        fetchFn: i
      };
      r(e);
      return e;
    })();
    (this.#e === `infinite` ? le(this.options.pages) : this.options.behavior)?.onFetch(a, this);
    this.#n = this.state;
    if (this.state.fetchStatus === `idle` || this.state.fetchMeta !== a.fetchOptions?.meta) {
      this.#c({
        type: `fetch`,
        meta: a.fetchOptions?.meta
      });
    }
    let o = this.#a = B({
      initialPromise: t?.initialPromise,
      fn: a.fetchFn,
      onCancel: e => {
        if (e instanceof z && e.revert) {
          this.setState({
            ...this.#n,
            fetchStatus: `idle`
          });
        }
        n.abort();
      },
      onFail: (e, t) => {
        this.#c({
          type: `failed`,
          failureCount: e,
          error: t
        });
      },
      onPause: () => {
        this.#c({
          type: `pause`
        });
      },
      onContinue: () => {
        this.#c({
          type: `continue`
        });
      },
      retry: a.options.retry,
      retryDelay: a.options.retryDelay,
      networkMode: a.options.networkMode,
      canRun: () => true
    });
    try {
      let e = await o.start();
      if (e === undefined) {
        throw Error(`${this.queryHash} data is undefined`);
      }
      this.setData(e);
      this.#r.config.onSuccess?.(e, this);
      this.#r.config.onSettled?.(e, this.state.error, this);
      return e;
    } catch (e) {
      if (e instanceof z) {
        if (e.silent) {
          return this.#a.promise;
        }
        if (e.revert) {
          if (this.state.data === undefined) {
            throw e;
          }
          return this.state.data;
        }
      }
      this.#c({
        type: `error`,
        error: e
      });
      this.#r.config.onError?.(e, this);
      this.#r.config.onSettled?.(this.state.data, e, this);
      throw e;
    } finally {
      if (this.#a === o) {
        this.#a = undefined;
      }
      this.scheduleGc();
    }
  }
  #c(e) {
    let t = t => {
      switch (e.type) {
        case `failed`:
          return {
            ...t,
            fetchFailureCount: e.failureCount,
            fetchFailureReason: e.error
          };
        case `pause`:
          return {
            ...t,
            fetchStatus: `paused`
          };
        case `continue`:
          return {
            ...t,
            fetchStatus: `fetching`
          };
        case `fetch`:
          return {
            ...t,
            ...U(t.data, this.options),
            fetchMeta: e.meta ?? null
          };
        case `success`:
          let n = {
            ...t,
            ...W(e.data, e.dataUpdatedAt),
            dataUpdateCount: t.dataUpdateCount + 1,
            ...(!e.manual && {
              fetchStatus: `idle`,
              fetchFailureCount: 0,
              fetchFailureReason: null
            })
          };
          this.#n = e.manual ? n : undefined;
          return n;
        case `error`:
          let r = e.error;
          return {
            ...t,
            error: r,
            errorUpdateCount: t.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: t.fetchFailureCount + 1,
            fetchFailureReason: r,
            fetchStatus: `idle`,
            status: `error`,
            isInvalidated: true
          };
        case `invalidate`:
          return {
            ...t,
            isInvalidated: true
          };
        case `setState`:
          return {
            ...t,
            ...e.state
          };
      }
    };
    this.state = t(this.state);
    I.batch(() => {
      this.observers.slice().forEach(e => {
        e.onQueryUpdate();
      });
      this.#r.notify({
        query: this,
        type: `updated`,
        action: e
      });
    });
  }
};
function U(e, t) {
  return {
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchStatus: R(t.networkMode) ? `fetching` : `paused`,
    ...(e === undefined && {
      error: null,
      status: `pending`
    })
  };
}
function W(e, t) {
  return {
    data: e,
    dataUpdatedAt: t ?? Date.now(),
    error: null,
    isInvalidated: false,
    status: `success`
  };
}
function G(e) {
  let t = typeof e.initialData == `function` ? e.initialData() : e.initialData;
  let n = t !== undefined;
  let r = n ? typeof e.initialDataUpdatedAt == `function` ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
  return {
    data: t,
    dataUpdateCount: 0,
    dataUpdatedAt: n ? r ?? Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: false,
    status: n ? `success` : `pending`,
    fetchStatus: `idle`
  };
}
var fe = class extends P {
  #e;
  #t = undefined;
  #n = undefined;
  #r = undefined;
  #i;
  #a;
  #o;
  #s;
  #c;
  #l;
  #u;
  #d;
  #f;
  #p = new Set();
  constructor(e, t) {
    super();
    this.options = t;
    this.#e = e;
    this.#o = null;
    this.bindMethods();
    this.setOptions(t);
  }
  bindMethods() {
    this.refetch = this.refetch.bind(this);
  }
  onSubscribe() {
    if (this.listeners.size === 1) {
      this.#t.addObserver(this);
      if (K(this.#t, this.options)) {
        this.#m();
      } else {
        this.updateResult();
      }
      this.#y();
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.destroy();
    }
  }
  shouldFetchOnReconnect() {
    return q(this.#t, this.options, this.options.refetchOnReconnect);
  }
  shouldFetchOnWindowFocus() {
    return q(this.#t, this.options, this.options.refetchOnWindowFocus);
  }
  destroy() {
    this.listeners = new Set();
    this.#b();
    this.#x();
    this.#t.removeObserver(this);
  }
  setOptions(e) {
    let t = this.options;
    let n = this.#t;
    this.options = this.#e.defaultQueryOptions(e);
    if (this.options.enabled !== undefined && typeof this.options.enabled != `boolean` && typeof this.options.enabled != `function` && typeof v(this.options.enabled, this.#t) != `boolean`) {
      throw Error(`Expected enabled to be a boolean or a callback that returns a boolean`);
    }
    this.#S();
    this.#t.setOptions(this.options);
    if (t._defaulted && !T(this.options, t)) {
      this.#e.getQueryCache().notify({
        type: `observerOptionsUpdated`,
        query: this.#t,
        observer: this
      });
    }
    let r = this.hasListeners();
    if (r && J(this.#t, n, this.options, t)) {
      this.#m();
    }
    this.updateResult();
    if (r && (this.#t !== n || v(this.options.enabled, this.#t) !== v(t.enabled, this.#t) || v(this.options.staleTime, this.#t) !== v(t.staleTime, this.#t))) {
      this.#g();
    }
    let i = this.#_();
    if (r && (this.#t !== n || v(this.options.enabled, this.#t) !== v(t.enabled, this.#t) || i !== this.#f)) {
      this.#v(i);
    }
  }
  getOptimisticResult(e) {
    let t = this.#e.getQueryCache().build(this.#e, e);
    let n = this.createResult(t, e);
    if (!T(this.getCurrentResult(), n)) {
      this.#r = n;
      this.#a = this.options;
      this.#i = this.#t.state;
    }
    return n;
  }
  getCurrentResult() {
    return this.#r;
  }
  trackResult(e, t) {
    return new Proxy(e, {
      get: (e, n) => {
        this.trackProp(n);
        t?.(n);
        return Reflect.get(e, n);
      }
    });
  }
  trackProp(e) {
    this.#p.add(e);
  }
  getCurrentQuery() {
    return this.#t;
  }
  refetch({
    ...e
  } = {}) {
    return this.fetch({
      ...e
    });
  }
  fetchOptimistic(e) {
    let t = this.#e.defaultQueryOptions(e);
    let n = this.#e.getQueryCache().build(this.#e, t);
    let r = () => {};
    let i;
    let a = new Promise(e => {
      i = e;
      r = this.#e.getQueryCache().subscribe(i => {
        if (i.type === `updated` && i.query.queryHash === n.queryHash && n.state.data !== undefined) {
          r();
          e(this.createResult(n, t));
        }
      });
    });
    return Promise.race([n.fetch().then(() => {
      let e = this.createResult(n, t);
      i?.(e);
      return e;
    }).finally(() => {
      r();
    }), a]);
  }
  fetch(e) {
    return this.#m({
      ...e,
      cancelRefetch: e.cancelRefetch ?? true
    }).then(() => {
      this.updateResult();
      return this.#r;
    });
  }
  #m(e) {
    this.#S();
    let t = this.#t.fetch(this.options, e);
    if (!e?.throwOnError) {
      t = t.catch(m);
    }
    return t;
  }
  #h(e) {
    return !N() && v(this.options.enabled, this.#t) !== false && g(e);
  }
  #g() {
    this.#b();
    let e = v(this.options.staleTime, this.#t);
    if (this.#r.isStale || !this.#h(e)) {
      return;
    }
    let t = _(this.#r.dataUpdatedAt, e) + 1;
    this.#u = d.setTimeout(() => {
      if (!this.#r.isStale) {
        this.updateResult();
      }
    }, t);
  }
  #_() {
    return v(this.options.refetchInterval, this.#t) ?? false;
  }
  #v(e) {
    this.#x();
    this.#f = e;
    if (this.#f !== 0 && this.#h(this.#f)) {
      this.#d = d.setInterval(() => {
        if (this.options.refetchIntervalInBackground || F.isFocused()) {
          this.#m();
        }
      }, this.#f);
    }
  }
  #y() {
    this.#g();
    this.#v(this.#_());
  }
  #b() {
    if (this.#u !== undefined) {
      d.clearTimeout(this.#u);
      this.#u = undefined;
    }
  }
  #x() {
    if (this.#d !== undefined) {
      d.clearInterval(this.#d);
      this.#d = undefined;
    }
  }
  createResult(e, t) {
    let n = this.#t;
    let r = this.options;
    let i = this.#r;
    let a = this.#i;
    let o = this.#a;
    let s = e === n ? this.#n : e.state;
    let {
      state: c
    } = e;
    let l = {
      ...c
    };
    let u = false;
    let d;
    if (t._optimisticResults) {
      let i = this.hasListeners();
      let a = !i && K(e, t);
      let o = i && J(e, n, t, r);
      if (a || o) {
        l = {
          ...l,
          ...U(c.data, e.options)
        };
      }
      if (t._optimisticResults === `isRestoring`) {
        l.fetchStatus = `idle`;
      }
    }
    let {
      error: f,
      errorUpdatedAt: p,
      status: m
    } = l;
    d = l.data;
    let h = false;
    if (t.placeholderData !== undefined && d === undefined && m === `pending`) {
      let e;
      if (i?.isPlaceholderData && t.placeholderData === o?.placeholderData) {
        e = i.data;
        h = true;
      } else {
        e = typeof t.placeholderData == `function` ? t.placeholderData(this.#l?.state.data, this.#l) : t.placeholderData;
      }
      if (e !== undefined) {
        m = `success`;
        d = k(i?.data, e, t);
        u = true;
      }
    }
    if (t.select && d !== undefined && !h) {
      if (i && d === a?.data && t.select === this.#s) {
        d = this.#c;
      } else {
        try {
          this.#s = t.select;
          d = t.select(d);
          d = k(i?.data, d, t);
          this.#c = d;
          this.#o = null;
        } catch (e) {
          this.#o = e;
        }
      }
    } else if (d === undefined) {
      this.#o = null;
    }
    if (this.#o) {
      f = this.#o;
      d = this.#c;
      p = Date.now();
      m = `error`;
      u = false;
    }
    let g = l.fetchStatus === `fetching`;
    let _ = m === `pending`;
    let y = m === `error`;
    let b = _ && g;
    let x = d !== undefined;
    return {
      status: m,
      fetchStatus: l.fetchStatus,
      isPending: _,
      isSuccess: m === `success`,
      isError: y,
      isInitialLoading: b,
      isLoading: b,
      data: d,
      dataUpdatedAt: l.dataUpdatedAt,
      error: f,
      errorUpdatedAt: p,
      failureCount: l.fetchFailureCount,
      failureReason: l.fetchFailureReason,
      errorUpdateCount: l.errorUpdateCount,
      isFetched: e.isFetched(),
      isFetchedAfterMount: l.dataUpdateCount > s.dataUpdateCount || l.errorUpdateCount > s.errorUpdateCount,
      isFetching: g,
      isRefetching: g && !_,
      isLoadingError: y && !x,
      isPaused: l.fetchStatus === `paused`,
      isPlaceholderData: u,
      isRefetchError: y && x,
      isStale: Y(e, t),
      refetch: this.refetch,
      isEnabled: v(t.enabled, e) !== false
    };
  }
  updateResult() {
    let e = this.#r;
    let t = this.createResult(this.#t, this.options);
    this.#i = this.#t.state;
    this.#a = this.options;
    if (this.#i.data !== undefined) {
      this.#l = this.#t;
    }
    if (T(t, e)) {
      return;
    }
    this.#r = t;
    let n = (() => {
      if (!e) {
        return true;
      }
      let {
        notifyOnChangeProps: t
      } = this.options;
      let n = typeof t == `function` ? t() : t;
      if (n === `all` || !n && !this.#p.size) {
        return true;
      }
      let r = new Set(n ?? this.#p);
      if (this.options.throwOnError) {
        r.add(`error`);
      }
      return Object.keys(this.#r).some(t => {
        let n = t;
        return this.#r[n] !== e[n] && r.has(n);
      });
    })();
    I.batch(() => {
      if (n) {
        this.listeners.forEach(e => {
          e(this.#r);
        });
      }
      this.#e.getQueryCache().notify({
        query: this.#t,
        type: `observerResultsUpdated`
      });
    });
  }
  #S() {
    let e = this.#e.getQueryCache().build(this.#e, this.options);
    if (e === this.#t) {
      return;
    }
    let t = this.#t;
    this.#t = e;
    this.#n = e.state;
    if (this.hasListeners()) {
      t?.removeObserver(this);
      e.addObserver(this);
    }
  }
  onQueryUpdate() {
    this.updateResult();
    if (this.hasListeners()) {
      this.#y();
    }
  }
};
function pe(e, t) {
  return v(t.enabled, e) !== false && e.state.data === undefined && (e.state.status !== `error` || v(t.retryOnMount, e) !== false);
}
function K(e, t) {
  return pe(e, t) || e.state.data !== undefined && q(e, t, t.refetchOnMount);
}
function q(e, t, n) {
  if (v(t.enabled, e) !== false && v(t.staleTime, e) !== `static`) {
    let r = v(n, e);
    return r === `always` || r !== false && Y(e, t);
  }
  return false;
}
function J(e, t, n, r) {
  return (e !== t || v(r.enabled, e) === false) && (!n.suspense || e.state.status !== `error`) && Y(e, n);
}
function Y(e, t) {
  return v(t.enabled, e) !== false && e.isStaleByTime(v(t.staleTime, e));
}
var me = class extends V {
  #e;
  #t;
  #n;
  #r;
  constructor(e) {
    super();
    this.#e = e.client;
    this.mutationId = e.mutationId;
    this.#n = e.mutationCache;
    this.#t = [];
    this.state = e.state || X();
    this.setOptions(e.options);
    this.scheduleGc();
  }
  setOptions(e) {
    this.options = e;
    this.updateGcTime(this.options.gcTime);
  }
  get meta() {
    return this.options.meta;
  }
  addObserver(e) {
    if (!this.#t.includes(e)) {
      this.#t.push(e);
      this.clearGcTimeout();
      this.#n.notify({
        type: `observerAdded`,
        mutation: this,
        observer: e
      });
    }
  }
  removeObserver(e) {
    this.#t = this.#t.filter(t => t !== e);
    this.scheduleGc();
    this.#n.notify({
      type: `observerRemoved`,
      mutation: this,
      observer: e
    });
  }
  optionalRemove() {
    if (!this.#t.length) {
      if (this.state.status === `pending`) {
        this.scheduleGc();
      } else {
        this.#n.remove(this);
      }
    }
  }
  continue() {
    return this.#r?.continue() ?? (this.state.status === `pending` ? this.execute(this.state.variables) : Promise.resolve());
  }
  async execute(e) {
    let t = () => {
      this.#i({
        type: `continue`
      });
    };
    let n = {
      client: this.#e,
      meta: this.options.meta,
      mutationKey: this.options.mutationKey
    };
    let r = this.#r = B({
      fn: () => this.options.mutationFn ? this.options.mutationFn(e, n) : Promise.reject(Error(`No mutationFn found`)),
      onFail: (e, t) => {
        this.#i({
          type: `failed`,
          failureCount: e,
          error: t
        });
      },
      onPause: () => {
        this.#i({
          type: `pause`
        });
      },
      onContinue: t,
      retry: this.options.retry ?? 0,
      retryDelay: this.options.retryDelay,
      networkMode: this.options.networkMode,
      canRun: () => this.#n.canRun(this)
    });
    let i = this.state.status === `pending`;
    let a = !r.canStart();
    try {
      if (i) {
        t();
      } else {
        this.#i({
          type: `pending`,
          variables: e,
          isPaused: a
        });
        if (this.#n.config.onMutate) {
          await this.#n.config.onMutate(e, this, n);
        }
        let t = await this.options.onMutate?.(e, n);
        if (t !== this.state.context) {
          this.#i({
            type: `pending`,
            context: t,
            variables: e,
            isPaused: a
          });
        }
      }
      let o = await r.start();
      await this.#n.config.onSuccess?.(o, e, this.state.context, this, n);
      await this.options.onSuccess?.(o, e, this.state.context, n);
      await this.#n.config.onSettled?.(o, null, this.state.variables, this.state.context, this, n);
      await this.options.onSettled?.(o, null, e, this.state.context, n);
      this.#i({
        type: `success`,
        data: o
      });
      return o;
    } catch (t) {
      try {
        await this.#n.config.onError?.(t, e, this.state.context, this, n);
      } catch (e) {
        Promise.reject(e);
      }
      try {
        await this.options.onError?.(t, e, this.state.context, n);
      } catch (e) {
        Promise.reject(e);
      }
      try {
        await this.#n.config.onSettled?.(undefined, t, this.state.variables, this.state.context, this, n);
      } catch (e) {
        Promise.reject(e);
      }
      try {
        await this.options.onSettled?.(undefined, t, e, this.state.context, n);
      } catch (e) {
        Promise.reject(e);
      }
      this.#i({
        type: `error`,
        error: t
      });
      throw t;
    } finally {
      if (this.#r === r) {
        this.#r = undefined;
      }
      this.#n.runNext(this);
    }
  }
  #i(e) {
    let t = t => {
      switch (e.type) {
        case `failed`:
          return {
            ...t,
            failureCount: e.failureCount,
            failureReason: e.error
          };
        case `pause`:
          return {
            ...t,
            isPaused: true
          };
        case `continue`:
          return {
            ...t,
            isPaused: false
          };
        case `pending`:
          return {
            ...t,
            context: e.context,
            data: undefined,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: e.isPaused,
            status: `pending`,
            variables: e.variables,
            submittedAt: Date.now()
          };
        case `success`:
          return {
            ...t,
            data: e.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: `success`,
            isPaused: false
          };
        case `error`:
          return {
            ...t,
            data: undefined,
            error: e.error,
            failureCount: t.failureCount + 1,
            failureReason: e.error,
            isPaused: false,
            status: `error`
          };
      }
    };
    this.state = t(this.state);
    I.batch(() => {
      this.#t.forEach(t => {
        t.onMutationUpdate(e);
      });
      this.#n.notify({
        mutation: this,
        type: `updated`,
        action: e
      });
    });
  }
};
function X() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: `idle`,
    variables: undefined,
    submittedAt: 0
  };
}
var he = class extends P {
  #e;
  #t;
  #n;
  constructor(e = {}) {
    super();
    this.config = e;
    this.#e = new Set();
    this.#t = new Map();
    this.#n = 0;
  }
  build(e, t, n) {
    let r = new me({
      client: e,
      mutationCache: this,
      mutationId: ++this.#n,
      options: e.defaultMutationOptions(t),
      state: n
    });
    this.add(r);
    return r;
  }
  add(e) {
    this.#e.add(e);
    let t = Z(e);
    if (typeof t == `string`) {
      let n = this.#t.get(t);
      if (n) {
        n.push(e);
      } else {
        this.#t.set(t, [e]);
      }
    }
    this.notify({
      type: `added`,
      mutation: e
    });
  }
  remove(e) {
    if (this.#e.delete(e)) {
      let t = Z(e);
      if (typeof t == `string`) {
        let n = this.#t.get(t);
        if (n) {
          if (n.length > 1) {
            let t = n.indexOf(e);
            if (t !== -1) {
              n.splice(t, 1);
            }
          } else if (n[0] === e) {
            this.#t.delete(t);
          }
        }
      }
    }
    this.notify({
      type: `removed`,
      mutation: e
    });
  }
  canRun(e) {
    let t = Z(e);
    if (typeof t == `string`) {
      let n = this.#t.get(t)?.find(e => e.state.status === `pending`);
      return !n || n === e;
    }
    return true;
  }
  runNext(e) {
    let t = Z(e);
    if (typeof t == `string`) {
      return this.#t.get(t)?.find(t => t !== e && t.state.isPaused)?.continue() ?? Promise.resolve();
    } else {
      return Promise.resolve();
    }
  }
  clear() {
    I.batch(() => {
      this.#e.forEach(e => {
        this.notify({
          type: `removed`,
          mutation: e
        });
      });
      this.#e.clear();
      this.#t.clear();
    });
  }
  getAll() {
    return Array.from(this.#e);
  }
  find(e) {
    let t = {
      exact: true,
      ...e
    };
    return this.getAll().find(e => b(t, e));
  }
  findAll(e = {}) {
    return this.getAll().filter(t => b(e, t));
  }
  notify(e) {
    I.batch(() => {
      this.listeners.forEach(t => {
        t(e);
      });
    });
  }
  resumePausedMutations() {
    let e = this.getAll().filter(e => e.state.isPaused);
    return I.batch(() => Promise.all(e.map(e => e.continue().catch(m))));
  }
};
function Z(e) {
  return e.options.scope?.id;
}
var ge = class extends P {
  #e;
  #t = undefined;
  #n;
  #r;
  constructor(e, t) {
    super();
    this.#e = e;
    this.setOptions(t);
    this.bindMethods();
    this.#i();
  }
  bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  }
  setOptions(e) {
    let t = this.options;
    this.options = this.#e.defaultMutationOptions(e);
    if (!T(this.options, t)) {
      this.#e.getMutationCache().notify({
        type: `observerOptionsUpdated`,
        mutation: this.#n,
        observer: this
      });
    }
    if (t?.mutationKey && this.options.mutationKey && S(t.mutationKey) !== S(this.options.mutationKey)) {
      this.reset();
    } else if (this.#n?.state.status === `pending`) {
      this.#n.setOptions(this.options);
    }
  }
  onSubscribe() {
    if (this.listeners.size === 1 && this.#n) {
      this.#n.addObserver(this);
      this.#i();
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.#n?.removeObserver(this);
    }
  }
  onMutationUpdate(e) {
    this.#i();
    this.#a(e);
  }
  getCurrentResult() {
    return this.#t;
  }
  reset() {
    this.#n?.removeObserver(this);
    this.#n = undefined;
    this.#i();
    this.#a();
  }
  mutate(e, t) {
    this.#r = t;
    this.#n?.removeObserver(this);
    this.#n = this.#e.getMutationCache().build(this.#e, this.options);
    this.#n.addObserver(this);
    return this.#n.execute(e);
  }
  #i() {
    let e = this.#n?.state ?? X();
    this.#t = {
      ...e,
      isPending: e.status === `pending`,
      isSuccess: e.status === `success`,
      isError: e.status === `error`,
      isIdle: e.status === `idle`,
      mutate: this.mutate,
      reset: this.reset
    };
  }
  #a(e) {
    I.batch(() => {
      if (this.#r && this.hasListeners()) {
        let t = this.#t.variables;
        let n = this.#t.context;
        let r = {
          client: this.#e,
          meta: this.options.meta,
          mutationKey: this.options.mutationKey
        };
        if (e?.type === `success`) {
          try {
            this.#r.onSuccess?.(e.data, t, n, r);
          } catch (e) {
            Promise.reject(e);
          }
          try {
            this.#r.onSettled?.(e.data, null, t, n, r);
          } catch (e) {
            Promise.reject(e);
          }
        } else if (e?.type === `error`) {
          try {
            this.#r.onError?.(e.error, t, n, r);
          } catch (e) {
            Promise.reject(e);
          }
          try {
            this.#r.onSettled?.(undefined, e.error, t, n, r);
          } catch (e) {
            Promise.reject(e);
          }
        }
      }
      this.listeners.forEach(e => {
        e(this.#t);
      });
    });
  }
};
var _e = class extends P {
  #e;
  constructor(e = {}) {
    super();
    this.config = e;
    this.#e = new Map();
  }
  build(e, t, n) {
    let r = t.queryKey;
    let i = t.queryHash ?? x(r, t);
    let a = this.get(i);
    if (!a) {
      a = new de({
        client: e,
        queryKey: r,
        queryHash: i,
        options: e.defaultQueryOptions(t),
        state: n,
        defaultOptions: e.getQueryDefaults(r)
      });
      this.add(a);
    }
    return a;
  }
  add(e) {
    if (!this.#e.has(e.queryHash)) {
      this.#e.set(e.queryHash, e);
      this.notify({
        type: `added`,
        query: e
      });
    }
  }
  remove(e) {
    let t = this.#e.get(e.queryHash);
    if (t) {
      e.destroy();
      if (t === e) {
        this.#e.delete(e.queryHash);
      }
      this.notify({
        type: `removed`,
        query: e
      });
    }
  }
  clear() {
    I.batch(() => {
      this.getAll().forEach(e => {
        this.remove(e);
      });
    });
  }
  get(e) {
    return this.#e.get(e);
  }
  getAll() {
    return [...this.#e.values()];
  }
  find(e) {
    let t = {
      exact: true,
      ...e
    };
    return this.getAll().find(e => y(t, e));
  }
  findAll(e = {}) {
    let t = this.getAll();
    if (Object.keys(e).length > 0) {
      return t.filter(t => y(e, t));
    } else {
      return t;
    }
  }
  notify(e) {
    I.batch(() => {
      this.listeners.forEach(t => {
        t(e);
      });
    });
  }
  onFocus() {
    I.batch(() => {
      this.getAll().forEach(e => {
        e.onFocus();
      });
    });
  }
  onOnline() {
    I.batch(() => {
      this.getAll().forEach(e => {
        e.onOnline();
      });
    });
  }
};
var ve = class {
  #e;
  #t;
  #n;
  #r;
  #i;
  #a;
  #o;
  #s;
  constructor(e = {}) {
    this.#e = e.queryCache || new _e();
    this.#t = e.mutationCache || new he();
    this.#n = e.defaultOptions || {};
    this.#r = new Map();
    this.#i = new Map();
    this.#a = 0;
  }
  mount() {
    this.#a++;
    if (this.#a === 1) {
      this.#o = F.subscribe(async e => {
        if (e) {
          await this.resumePausedMutations();
          this.#e.onFocus();
        }
      });
      this.#s = L.subscribe(async e => {
        if (e) {
          await this.resumePausedMutations();
          this.#e.onOnline();
        }
      });
    }
  }
  unmount() {
    this.#a--;
    if (this.#a === 0) {
      this.#o?.();
      this.#o = undefined;
      this.#s?.();
      this.#s = undefined;
    }
  }
  isFetching(e) {
    return this.#e.findAll({
      ...e,
      fetchStatus: `fetching`
    }).length;
  }
  isMutating(e) {
    return this.#t.findAll({
      ...e,
      status: `pending`
    }).length;
  }
  getQueryData(e) {
    let t = this.defaultQueryOptions({
      queryKey: e
    });
    return this.#e.get(t.queryHash)?.state.data;
  }
  ensureQueryData(e) {
    let t = this.defaultQueryOptions(e);
    let n = this.#e.build(this, t);
    let r = n.state.data;
    if (r === undefined) {
      return this.fetchQuery(e);
    } else {
      if (e.revalidateIfStale && n.isStaleByTime(v(t.staleTime, n))) {
        this.prefetchQuery(t);
      }
      return Promise.resolve(r);
    }
  }
  getQueriesData(e) {
    return this.#e.findAll(e).map(({
      queryKey: e,
      state: t
    }) => [e, t.data]);
  }
  setQueryData(e, t, n) {
    let r = this.defaultQueryOptions({
      queryKey: e
    });
    let i = this.#e.get(r.queryHash)?.state.data;
    let a = h(t, i);
    if (a !== undefined) {
      return this.#e.build(this, r).setData(a, {
        ...n,
        manual: true
      });
    }
  }
  setQueriesData(e, t, n) {
    return I.batch(() => this.#e.findAll(e).map(({
      queryKey: e
    }) => [e, this.setQueryData(e, t, n)]));
  }
  getQueryState(e) {
    let t = this.defaultQueryOptions({
      queryKey: e
    });
    return this.#e.get(t.queryHash)?.state;
  }
  removeQueries(e) {
    let t = this.#e;
    I.batch(() => {
      t.findAll(e).forEach(e => {
        t.remove(e);
      });
    });
  }
  resetQueries(e, t) {
    let n = this.#e;
    return I.batch(() => {
      let r = n.findAll(e);
      let i = new Set(r);
      r.forEach(e => {
        e.reset();
      });
      return this.refetchQueries({
        type: `active`,
        predicate: e => i.has(e)
      }, t);
    });
  }
  cancelQueries(e, t = {}) {
    let n = {
      revert: true,
      ...t
    };
    let r = I.batch(() => this.#e.findAll(e).map(e => e.cancel(n)));
    return Promise.all(r).then(m).catch(m);
  }
  invalidateQueries(e, t = {}) {
    return I.batch(() => {
      this.#e.findAll(e).forEach(e => {
        e.invalidate();
      });
      if (e?.refetchType === `none`) {
        return Promise.resolve();
      } else {
        return this.refetchQueries({
          ...e,
          type: e?.refetchType ?? e?.type ?? `active`
        }, t);
      }
    });
  }
  refetchQueries(e, t = {}) {
    let n = {
      ...t,
      cancelRefetch: t.cancelRefetch ?? true
    };
    let r = I.batch(() => this.#e.findAll(e).filter(e => !e.isDisabled() && !e.isStatic()).map(e => {
      let t = e.fetch(undefined, n);
      if (!n.throwOnError) {
        t = t.catch(m);
      }
      if (e.state.fetchStatus === `paused`) {
        return Promise.resolve();
      } else {
        return t;
      }
    }));
    return Promise.all(r).then(m);
  }
  async query(e) {
    let t = this.defaultQueryOptions(e);
    if (t.retry === undefined) {
      t.retry = false;
    }
    let n = this.#e.build(this, t);
    let r = n.isStaleByTime(v(t.staleTime, n)) ? await n.fetch(t) : n.state.data;
    let i = t.select;
    if (i) {
      return i(r);
    } else {
      return r;
    }
  }
  fetchQuery(e) {
    let t = this.defaultQueryOptions(e);
    if (t.retry === undefined) {
      t.retry = false;
    }
    let n = this.#e.build(this, t);
    if (n.isStaleByTime(v(t.staleTime, n))) {
      return n.fetch(t);
    } else {
      return Promise.resolve(n.state.data);
    }
  }
  prefetchQuery(e) {
    return this.fetchQuery(e).then(m).catch(m);
  }
  infiniteQuery(e) {
    e._type = `infinite`;
    return this.query(e);
  }
  fetchInfiniteQuery(e) {
    e._type = `infinite`;
    return this.fetchQuery(e);
  }
  prefetchInfiniteQuery(e) {
    return this.fetchInfiniteQuery(e).then(m).catch(m);
  }
  ensureInfiniteQueryData(e) {
    e._type = `infinite`;
    return this.ensureQueryData(e);
  }
  resumePausedMutations() {
    if (L.isOnline()) {
      return this.#t.resumePausedMutations();
    } else {
      return Promise.resolve();
    }
  }
  getQueryCache() {
    return this.#e;
  }
  getMutationCache() {
    return this.#t;
  }
  getDefaultOptions() {
    return this.#n;
  }
  setDefaultOptions(e) {
    this.#n = e;
  }
  setQueryDefaults(e, t) {
    this.#r.set(S(e), {
      queryKey: e,
      defaultOptions: t
    });
  }
  getQueryDefaults(e) {
    let t = [...this.#r.values()];
    let n = {};
    t.forEach(t => {
      if (C(e, t.queryKey)) {
        Object.assign(n, t.defaultOptions);
      }
    });
    return n;
  }
  setMutationDefaults(e, t) {
    this.#i.set(S(e), {
      mutationKey: e,
      defaultOptions: t
    });
  }
  getMutationDefaults(e) {
    let t = [...this.#i.values()];
    let n = {};
    t.forEach(t => {
      if (C(e, t.mutationKey)) {
        Object.assign(n, t.defaultOptions);
      }
    });
    return n;
  }
  defaultQueryOptions(e) {
    if (e._defaulted) {
      return e;
    }
    let t = {
      ...this.#n.queries,
      ...this.getQueryDefaults(e.queryKey),
      ...e,
      _defaulted: true
    };
    t.queryHash ||= x(t.queryKey, t);
    if (t.refetchOnReconnect === undefined) {
      t.refetchOnReconnect = t.networkMode !== `always`;
    }
    if (t.throwOnError === undefined) {
      t.throwOnError = !!t.suspense;
    }
    if (!t.networkMode && t.persister) {
      t.networkMode = `offlineFirst`;
    }
    if (t.queryFn === A) {
      t.enabled = false;
    }
    return t;
  }
  defaultMutationOptions(e) {
    if (e?._defaulted) {
      return e;
    } else {
      return {
        ...this.#n.mutations,
        ...(e?.mutationKey && this.getMutationDefaults(e.mutationKey)),
        ...e,
        _defaulted: true
      };
    }
  }
  clear() {
    this.#e.clear();
    this.#t.clear();
  }
};
var Q = a.createContext(false);
var ye = () => a.useContext(Q);
Q.Provider;
function be() {
  let e = false;
  return {
    clearReset: () => {
      e = false;
    },
    reset: () => {
      e = true;
    },
    isReset: () => e
  };
}
var $ = a.createContext(be());
var xe = () => a.useContext($);
var Se = (e, t, n) => {
  let r = n?.state.error && typeof e.throwOnError == `function` ? M(e.throwOnError, [n.state.error, n]) : e.throwOnError;
  if (e.suspense || r) {
    if (!t.isReset()) {
      e.retryOnMount = false;
    }
  }
};
var Ce = e => {
  a.useEffect(() => {
    e.clearReset();
  }, [e]);
};
var we = ({
  result: e,
  errorResetBoundary: t,
  throwOnError: n,
  query: r,
  suspense: i
}) => e.isError && !t.isReset() && !e.isFetching && r && (i && e.data === undefined || M(n, [e.error, r]));
var Te = e => {
  if (e.suspense) {
    let t = 1000;
    let n = e => e === `static` ? e : Math.max(e ?? t, t);
    let r = e.staleTime;
    e.staleTime = typeof r == `function` ? (...e) => n(r(...e)) : n(r);
    if (typeof e.gcTime == `number`) {
      e.gcTime = Math.max(e.gcTime, t);
    }
  }
};
var Ee = (e, t) => e?.suspense && t.isPending;
var De = (e, t, n) => t.fetchOptimistic(e).catch(() => {
  n.clearReset();
});
function Oe(e, t, n) {
  let r = ye();
  let i = xe();
  let o = c(n);
  let s = o.defaultQueryOptions(e);
  let l = o.getQueryCache().get(s.queryHash);
  let u = e.subscribed !== false;
  s._optimisticResults = r ? `isRestoring` : u ? `optimistic` : undefined;
  Te(s);
  Se(s, i, l);
  Ce(i);
  let [d] = a.useState(() => new t(o, s));
  let f = d.getOptimisticResult(s);
  let p = !r && u;
  a.useSyncExternalStore(a.useCallback(e => {
    let t = p ? d.subscribe(I.batchCalls(e)) : m;
    d.updateResult();
    return t;
  }, [d, p]), () => d.getCurrentResult(), () => d.getCurrentResult());
  a.useEffect(() => {
    d.setOptions(s);
  }, [s, d]);
  if (Ee(s, f)) {
    throw De(s, d, i);
  }
  if (we({
    result: f,
    errorResetBoundary: i,
    throwOnError: s.throwOnError,
    query: l,
    suspense: s.suspense
  })) {
    throw f.error;
  }
  if (s.notifyOnChangeProps) {
    return f;
  } else {
    return d.trackResult(f);
  }
}
function ke(e, t) {
  return Oe(e, fe, t);
}
function Ae(e, t) {
  let n = c(t);
  let [r] = a.useState(() => new ge(n, e));
  a.useEffect(() => {
    r.setOptions(e);
  }, [r, e]);
  let i = a.useSyncExternalStore(a.useCallback(e => r.subscribe(I.batchCalls(e)), [r]), () => r.getCurrentResult(), () => r.getCurrentResult());
  let o = a.useCallback((...e) => {
    r.mutate(e[0], e[1]).catch(m);
  }, [r]);
  if (i.error && M(r.options.throwOnError, [i.error])) {
    throw i.error;
  }
  return {
    ...i,
    mutate: o,
    mutateAsync: i.mutate
  };
}
export { c as a, l as i, ke as n, i as o, ve as r, Ae as t };